import { render, staticRenderFns } from "./UsersManagement.vue?vue&type=template&id=818d1514&scoped=true&"
import script from "./UsersManagement.vue?vue&type=script&lang=js&"
export * from "./UsersManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "818d1514",
  null
  
)

export default component.exports